import { createNamespacedHelpers } from 'vuex'
const { mapGetters: attendanceGettersMap } = createNamespacedHelpers('attendance')
import { POSITIVE_IMAGE_EXAM_VALUES } from '@/components/AttendanceForm/espondiloartrites/constants/asasPhase'

const casparKeys = [
  'caspar_psoriase',
  'caspar_distrofia_ungueal',
  'caspar_fator_reumatoide_negativo',
  'caspar_dactilite',
  'caspar_evidencia_neoformacao_ossea',
]

export default {
  computed: {
    ...attendanceGettersMap(['getPhaseDataByKey']),
    computedCaspar() {
      const phaseData = this.getPhaseDataByKey('asas')
      if (
        !phaseData ||
        casparKeys.some((key) => phaseData[key] == null) ||
        (phaseData['caspar_psoriase'] && !phaseData['caspar_condicao_psoriase'])
      ) {
        return '?'
      }

      return casparKeys.reduce((previousValue, key) => {
        return (
          previousValue +
          (!phaseData[key]
            ? 0
            : key === 'caspar_psoriase'
            ? phaseData['caspar_condicao_psoriase'] === 'ATUAL'
              ? 2
              : 1
            : 1)
        )
      }, 0)
    },
    computedSacroileiteImagem() {
      const value = this.getPhaseDataByKey('asas')?.possui_sacroileite_exame_imagem

      if (!this.getPhaseDataByKey('asas') || value == null) {
        return '?'
      }
      if (POSITIVE_IMAGE_EXAM_VALUES.includes(value)) {
        return '+'
      } else {
        return '-'
      }
    },
    computedEva() {
      if (!this.getPhaseDataByKey('atividades_doenca')) {
        return '?'
      }
      return this.getPhaseDataByKey('atividades_doenca').escala_visual_analogica
    },
    computedEvaClass() {
      if (this.computedEva == null || this.computedEva === '?') {
        return 'grey--text text-lighten-1'
      }

      if (this.computedEva > 2 && this.computedEva < 6) {
        return 'yellow--text'
      } else if (this.computedEva >= 6 && this.computedEva < 8) {
        return 'orange--text'
      } else if (this.computedEva >= 8) {
        return 'big-number--negative'
      }

      return ''
    },
  },
}
